import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterMenu } from '../../shared/models/filter-menu';
import { PanelList } from '../../shared/models/panel-list';
import { SessionAuditTrialDetails } from '../models/session-audit-trial-details';
import { SortMenu } from '../../shared/models/sort-menu';

@Component({
  selector: 'app-session-audit-summary',
  templateUrl: './session-audit-summary.component.html',
  styleUrls: ['./session-audit-summary.component.scss']
})
export class SessionAuditSummaryComponent {
  @Input() auditSummaryDetails!: SessionAuditTrialDetails[];
  @Output() attributeDetailsOfTransaction = new EventEmitter();
  isSessionAuditSummaryLoaded: boolean = false;
  sessionAuditSummaryInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: true,
    enableSort: true,
    filters: [],
    sort: [],
    enableToggling: false,
    enableSelection: false,
    enablePanelCardClick: true,
    enablePanelHighLight:true
  };

  constructor() { }

  ngOnInit(): void {
    this.bindSessionAuditSummary();
  }

  bindSessionAuditSummary = () => {
    this.sessionAuditSummaryInput.lists = this.auditSummaryDetails;
    this.sessionAuditSummaryInput.filters = this.getFiltersForSessionAuditList();
    this.sessionAuditSummaryInput.sort = this.getSortFieldsForSessionAuditList();
    this.sessionAuditSummaryInput.clearSelection = true;
    this.isSessionAuditSummaryLoaded = true;
    this.sessionAuditSummaryInput = { ...this.sessionAuditSummaryInput };
  }
  private getFiltersForSessionAuditList = (): FilterMenu[] => {
    let filters: FilterMenu[] = [];
    filters.push(
      {
        filterDisplayName: 'User',
        filterFieldName: 'user',
      },
      {
        filterDisplayName: 'Action',
        filterFieldName: 'action',
      }
    );
    return filters;
  };
  private getSortFieldsForSessionAuditList = (): SortMenu[] => {
    let sortMenu: SortMenu[] = [];
    sortMenu.push(
      {
        sortFieldDisplayName: 'User',
        sortFieldName: 'user',
      },
      {
        sortFieldDisplayName: 'Action',
        sortFieldName: 'action',
      }
    );
    return sortMenu;
  };
  showAuditAttributeDetails = (data: any) => {
    this.attributeDetailsOfTransaction.emit(data);;
  }
}
